'use client';

import React, { useState } from 'react';
import styles from './SpecialOfferBanner.module.css';
import { CustomImage as Image } from '../shared/custom-image';

interface SpecialOffer {
  id: string;
  endDate?: string;
  title: string | React.ReactNode;
  image?: string[];
  highlighted?: boolean;
}

interface SpecialOfferBannerProps {
  offers: SpecialOffer[];
  isSpecialRegion?: boolean;
}

// Styled components
const BannerContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.bannerContainer}>{children}</div>
);

const OffersImageContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.offersImageContainer}>{children}</div>
);

const Offer = ({
  highlighted,
  children,
}: {
  highlighted?: boolean;
  children: React.ReactNode;
}) => (
  <div
    className={styles.offer}
    data-highlighted={highlighted ? 'true' : 'false'}
  >
    {children}
  </div>
);

const OfferContent = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.offerContent}>{children}</div>
);

const OfferTitle = ({ children }: { children: React.ReactNode }) => (
  <h3 className={styles.offerTitle}>{children}</h3>
);

const OfferDescription = ({ children }: { children: React.ReactNode }) => (
  <p className={styles.offerDescription}>{children}</p>
);

export const NEVER_ENDING_DATE = '2123-12-31T23:59:59.999Z'; // Far future date (about 100 years)

/**
 * SpecialOfferBanner component
 * Displays special offers and promotions
 */
const SpecialOfferBanner: React.FC<SpecialOfferBannerProps> = ({
  offers,
  isSpecialRegion = false,
}) => {
  // State to track dismissed offers
  const [dismissedOffers] = useState<Set<string>>(new Set());

  // Calculate remaining time for time-limited offers
  // const calculateTimeRemaining = (endDate?: string): string | null => {
  //   // If no endDate provided, use the never-ending date
  //   const dateToUse = endDate === 'never' ? NEVER_ENDING_DATE : endDate;

  //   if (!dateToUse) return null;

  //   const end = new Date(dateToUse);
  //   const now = new Date();

  //   if (now > end) return null;

  //   const diffMs = end.getTime() - now.getTime();
  //   const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  //   if (diffDays > 1) {
  //     return `${diffDays} days left`;
  //   } else if (diffDays === 1) {
  //     return '1 day left';
  //   } else {
  //     const diffHours = Math.floor(
  //       (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  //     );
  //     return `${diffHours} hours left`;
  //   }
  // };

  // Filter offers: show only non-dismissed and valid offers
  const validOffers = offers.filter((offer) => {
    // Skip if dismissed
    if (dismissedOffers.has(offer.id)) return false;

    // Check if offer is within valid dates
    const now = new Date();
    // if (offer.startDate && new Date(offer.startDate) > now) return false;
    if (offer.endDate && new Date(offer.endDate) < now) return false;

    return true;
  });

  // Handle dismissing an offer
  // const dismissOffer = (id: string) => {
  //   setDismissedOffers((prev) => new Set([...prev, id]));
  // };

  // If no valid offers, don't render anything
  if (validOffers.length === 0) return null;

  return (
    <BannerContainer>
      {validOffers.map((offer) => {
        // const timeRemaining = calculateTimeRemaining(offer.endDate);

        return (
          <Offer key={offer.id} highlighted={offer.highlighted}>
            {/* <OfferIcon>TAG</OfferIcon> */}
            {offer.image && offer.image.length > 0 ? (
              <OffersImageContainer>
                {offer.image.map((img, index) => (
                  <Image src={img} alt="" height="40" width="40" key={index} />
                ))}
              </OffersImageContainer>
            ) : null}
            <OfferContent>
              <OfferTitle>
                {offer.title}
                {/* {offer.badgeText && <OfferBadge>{offer.badgeText}</OfferBadge>} */}
              </OfferTitle>

              <OfferDescription>
                {isSpecialRegion
                  ? // Display with local currency formatting for special regions
                    // offer.description
                    'speacial offer'
                  : // Use default formatting for standard regions
                    // offer.description.replace(/\$\d+/, (match) =>
                    //   displayPrice(parseInt(match.substring(1))).toString(),
                    // )}
                    null}
              </OfferDescription>
            </OfferContent>

            {/* {timeRemaining && <Timer>{timeRemaining}</Timer>} */}

            {/* <CloseButton
              onClick={() => dismissOffer(offer.id)}
              aria-label="Dismiss offer"
            >
              X
            </CloseButton> */}
          </Offer>
        );
      })}
    </BannerContainer>
  );
};

export default SpecialOfferBanner;
